import * as React from "react";
import { relativeDifference, adjustFormat } from "util/DateTime";
const RelativeTime = ({ dateTime: dateTimeProp = void 0, withoutSuffix = false }) => {
  const dateTime = dateTimeProp != null ? dateTimeProp : /* @__PURE__ */ new Date();
  const relativeTime = relativeDifference(dateTime, withoutSuffix);
  const dateTimeString = adjustFormat(dateTime, "internal");
  return /* @__PURE__ */ React.createElement("time", { dateTime: dateTimeString, title: dateTimeString }, relativeTime);
};
export default RelativeTime;
